import { StoreRolesService } from '../../../core/services/store-role.service';
import { Subscription } from 'rxjs';
import { CustomerService } from '../../../core/services/customer.service';
import { Component, OnInit } from '@angular/core';
import { RolesService } from 'src/app/core/services/roles.service';
import { LoginService } from 'src/app/core/services/login.service';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { Router } from '@angular/router';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { RolesWeight } from 'src/app/authentication/auth-helpers';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { LoadingService } from 'src/app/core/services/loading.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { TbAuthService } from '@tb/auth';

@Component({
    selector: 'tb-subscription-account',
    templateUrl: './subscription-account.component.html',
    styleUrls: ['./subscription-account.component.scss'],
})
export class SubscriptionAccountComponent implements OnInit {
    readingData = false;
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);
    isAdmin: boolean = false;
    isImpExpAdmin: boolean = false;
    isLogged: boolean = false;
    nfsVisible: boolean = false;
    hasAnAssociatedSubscription: boolean = false;
    loading = true;
    public title: string;
    public subtitle: string;
    public carContentTitle: string;
    public cartButtonText: string;
    public onPremiseContentTitle: string;
    public NewInstanceOnPremiseButtonText: string;
    public create_subs_title: string;
    public create_subs_title_mw: string;
    public create_newInstanceOnPremise_title: string;

    public cmsObj: CmsObject[];
    language: string;

    constructor(
        private rolesService: RolesService,
        private subscriptionService: SubscriptionService,
        private loginService: LoginService,
        private router: Router,
        public cmsService: CmsService,
        private workFlow: WorkFlowService,
        private variable: TranslatedVariables,
        private customerService: CustomerService,
        public loadingService: LoadingService,
        public storeRolesService: StoreRolesService,
        private authService: TbAuthService
    ) {}

    async ngOnInit() {
        this.loading = true;
        this.loadingService.setLoading(this.loading);
        this.isAdmin = this.rolesService.checkRolesMin(RolesWeight.COUSERADMIN);
        await this.getInfoSubscription();
        this.isImpExpAdmin = this.rolesService.checkSpecificRole(RolesWeight.APPLICATIONADMIN);
        await this.getCmsObj();
        this.cartButtonText = this.variable.gotoNewSubscription;
        this.carContentTitle = this.variable.createYourOwnConfiguration;
        this.onPremiseContentTitle = this.variable.createNewOnPremiseInstance;
        this.NewInstanceOnPremiseButtonText = this.variable.goTo;
        this.isLogged = this.authorizationProperties ? true : false;
        this.loading = false;
        this.loadingService.setLoading(this.loading);
        return this.storeRolesService.storeRoles$.map(async (storeRoles) => {
            if (storeRoles == null || storeRoles.length == 0) {
                if (this.storeRolesService?.IsInternal) {
                    await this.authService.logoff();
                    this.loginService.logOff$.next(true);
                } else {
                    this.loginService.logoutMYZ();
                }
                this.loginService.clearStorage();
                this.storeRolesService.Clear();
                window.location.reload();
            }
        });
    }

    async getCmsObj() {
        this.language = this.workFlow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'accountcomponent');
        this.create_subs_title = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.create_subs_title').ContentTranslation;
        this.create_subs_title_mw = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.create_subs_title_mw').ContentTranslation;
        this.create_newInstanceOnPremise_title = this.cmsObj.find(
            (x) => x.ContentName == 'accountcomponent.create_newInstanceOnPremise_title'
        ).ContentTranslation;
    }

    async getInfoSubscription() {
        let opRes = await this.subscriptionService.getSubscriptionsCountToPromise(this.authorizationProperties.accountName);
        this.hasAnAssociatedSubscription = opRes.Content;
    }
}
